import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
export default function useGetMailFolders() {
  return useQuery('get-mail-folders', async () => {
    const response = await makeApiRequest.get(apiEndPoints.MAILS_FOLDER);
    return response?.data;
  });
}
